import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { UseFormRegisterReturn } from "react-hook-form";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { Office } from "@/api/offices";
import { useMemo } from "react";
import { CodependentHandbookProps } from "../modals/modalBuilder";

export function NewOfficeHandbook(props: AutocompleteProps<Office>) {
  const items = useAppSelector((state) => state.handbooks.office);
  const nItems = useMemo(
    () =>
      items
        .map((item) => ({
          ...item,
          display_name: `${item.location_display_name} - ${item.display_name}`,
        }))
        .sort((a, b) => a.display_name.localeCompare(b.display_name)),
    [items],
  );

  return (
    <Autocomplete
      defaultItems={nItems}
      label="Офис"
      placeholder="Выберите офис"
      variant="bordered"
      {...props}>
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

export function CodependentOfficeHandbook(
  props: CodependentHandbookProps & AutocompleteProps<Office>,
) {
  const items = useAppSelector((state) => state.handbooks.office);
  const agreements = useAppSelector((state) => state.handbooks.agreements);

  const finalItems = useMemo(() => {
    const agreementId = Number(props.deps[0]) || 0;
    const agreement = agreements.find((a) => a.id === agreementId);

    if (!agreement || !agreement.offices) {
      return [];
    }

    const officeIds = agreement.offices.map((o) => o.officeId);

    return items
      .filter((office) => officeIds.includes(office.id))
      .map((item) => ({
        ...item,
        display_name: `${item.location_display_name} - ${item.display_name}`,
      }))
      .sort((a, b) => a.display_name.localeCompare(b.display_name));
  }, [props.deps, items, agreements]);

  return (
    <Autocomplete
      defaultItems={finalItems}
      label="Офис"
      placeholder="Выберите офис"
      variant="bordered"
      {...props}>
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

export function OfficeHandbook({
  register,
  isInvalid,
  errorMessage,
  defaultSelectedKey,
  onOfficeChange,
}: {
  register: UseFormRegisterReturn;
  isInvalid: boolean;
  errorMessage: string;
  defaultSelectedKey?: string;
  onOfficeChange?: (office: any) => void;
}) {
  const items = useAppSelector((state) => state.handbooks.office);

  return (
    <Autocomplete
      {...register}
      defaultItems={items}
      label="Офис"
      placeholder="Выберите офис"
      variant="bordered"
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      defaultSelectedKey={defaultSelectedKey}
      onSelectionChange={onOfficeChange}>
      {(item) => (
        <AutocompleteItem
          key={String(item.id)}>{`${item.display_name}`}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
